<template>
  <div v-if="icpLicense || publicSecurityRecord" class="apoc-record-bar">
    <div class="apoc-record-bar__items">
      <a
        v-if="icpLicense"
        class="apoc-record-bar__link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ icpLicense }}
      </a>
      <a
        v-if="publicSecurityRecord"
        class="apoc-record-bar__link"
        href="https://www.beian.gov.cn/portal/registerSystemInfo"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ publicSecurityRecord }}
      </a>
    </div>
  </div>
</template>

<script>
import { ensureSiteConfig, siteConfigState } from '@/store/site-config'

export default {
  name: 'ApocRecordBar',
  computed: {
    icpLicense () {
      return siteConfigState.icpLicense
    },
    publicSecurityRecord () {
      return siteConfigState.publicSecurityRecord
    }
  },
  created () {
    ensureSiteConfig()
  }
}
</script>

<style scoped>
.apoc-record-bar {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 1000;
  padding: 8px 14px;
  border-radius: 2px;
  background: rgba(8, 10, 8, 0.82);
  border: 1px solid rgba(223, 218, 194, 0.12);
  border-left: 2px solid var(--dz-rust, #a64f35);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  color: #a9aa9d;
  font-size: 11px;
  font-family: "SFMono-Regular", Consolas, monospace;
  line-height: 1.4;
  backdrop-filter: blur(6px);
}

.apoc-record-bar__items {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.apoc-record-bar__link {
  color: inherit;
  text-decoration: none;
}

.apoc-record-bar__link:hover {
  color: var(--dz-accent, #d0b861);
  text-decoration: underline;
}
</style>
